import type { AppStateSnapshot, AppStatus, ArErrorCode, StatusCopy } from "../types";

export const statusCopy = {
  initial: {
    message: "Pronto para iniciar",
  },
  "requesting-permission": {
    message: "A solicitar acesso à câmara…",
  },
  "camera-active": {
    message: "Aponte a câmara para o cartão Converto",
  },
  "target-detected": {
    message: "Experiência ativada",
  },
  "target-lost": {
    message: "Volte a apontar a câmara para o cartão",
  },
  "permission-denied": {
    message:
      "Não foi possível aceder à câmara. Autorize o acesso nas definições do navegador e volte a tentar.",
  },
  incompatible: {
    message: "Este dispositivo ou navegador não suporta a experiência.",
  },
  "technical-error": {
    message: "Ocorreu um erro ao iniciar a experiência. Atualize a página e tente novamente.",
  },
  "internal-browser": {
    message: "Abra esta experiência no Safari ou Chrome",
    title: "Abra esta experiência no Safari ou Chrome",
    body:
      "O navegador interno desta aplicação pode bloquear o acesso à câmara. Utilize o menu da aplicação e selecione «Abrir no navegador».",
  },
  "target-missing": {
    message:
      "Não foi possível carregar o alvo de reconhecimento. Verifique se o ficheiro do cartão está disponível e tente novamente.",
  },
} satisfies Record<AppStatus, StatusCopy>;

export type AppStateListener = (snapshot: AppStateSnapshot) => void;

export class AppStateStore {
  private snapshot: AppStateSnapshot = this.createSnapshot("initial");
  private readonly listeners = new Set<AppStateListener>();

  getState(): AppStateSnapshot {
    return this.snapshot;
  }

  transition(status: AppStatus, errorCode?: ArErrorCode): AppStateSnapshot {
    this.snapshot = this.createSnapshot(status, errorCode);
    this.emit();
    return this.snapshot;
  }

  reset(): AppStateSnapshot {
    return this.transition("initial");
  }

  subscribe(listener: AppStateListener): () => void {
    this.listeners.add(listener);
    listener(this.snapshot);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private createSnapshot(status: AppStatus, errorCode?: ArErrorCode): AppStateSnapshot {
    return {
      status,
      copy: statusCopy[status],
      errorCode,
    };
  }

  private emit(): void {
    for (const listener of this.listeners) {
      listener(this.snapshot);
    }
  }
}

export const appState = new AppStateStore();
